import { render } from "./appMain.vue?vue&type=template&id=78124bf1&scoped=true"
import script from "./appMain.vue?vue&type=script&lang=js"
export * from "./appMain.vue?vue&type=script&lang=js"

import "./appMain.vue?vue&type=style&index=0&id=78124bf1&lang=scss&scoped=true"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78124bf1"]])

export default __exports__